export const mockData = {
  states: [
    { value: 'MG', text: 'Carregando...' }
  ],

  stateData: {
    MG: {
      generalStats: {
        mediaSalarialOrg: 5234.89,
        maiorSalarioOrg: 12500.00,
        menorSalarioOrg: 2500.00,
        mediaSalarialGeral: 5500.00,
        maiorSalarioGeral: 13000.00,
        menorSalarioGeral: 2300.00,
        diferencaPercentual: -4.82,
        diferencaPercentualMaiorSalario: 0,
        diferencaPercentualMenorSalario: 0,
        totalCBOs: 45
      },
      estruturas: [
        {
          id: 1,
          nome: 'Tecnologia da Informação',
          mediaSalarialOrg: 8500.00,
          mediaSalarialGeral: 9200.00,
          diferencaPercentual: -7.61,
          cbos: [
            {
              codigo: '2124-05',
              descricao: 'Analista de Desenvolvimento',
              mediaSalarialOrg: 9200.00,
              menorSalarioOrg: 7500.00,
              maiorSalarioOrg: 12500.00,
              mediaSalarialGeral: 10000.00,
              menorSalarioGeral: 8000.00,
              maiorSalarioGeral: 13000.00,
              diferencaPercentual: -8.00
            },
            {
              codigo: '2123-10',
              descricao: 'Analista de Suporte',
              mediaSalarialOrg: 7800.00,
              menorSalarioOrg: 6500.00,
              maiorSalarioOrg: 9500.00,
              mediaSalarialGeral: 8400.00,
              menorSalarioGeral: 7000.00,
              maiorSalarioGeral: 10000.00,
              diferencaPercentual: -7.14
            }
          ]
        }
        // Adicione mais estruturas conforme necessário
      ]
    }
    // Adicione mais estados conforme necessário
  }
};
